import { Button, DataSource, HorizontalSpacer, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiReqdFldGrpExpandedStatus extends Layout {
    buttonAdd: Button;
    horizontalspacer1: HorizontalSpacer;
    labelRuleHeader: Label;
    sourceEdiRequiredFieldStatus: DataSource;
    tableEdiRequiredField: Table;
}
